var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 5.00016H4.99992C4.55789 5.00016 4.13397 5.17576 3.82141 5.48832C3.50885 5.80088 3.33325 6.2248 3.33325 6.66683V15.0002C3.33325 15.4422 3.50885 15.8661 3.82141 16.1787C4.13397 16.4912 4.55789 16.6668 4.99992 16.6668H13.3333C13.7753 16.6668 14.1992 16.4912 14.5118 16.1787C14.8243 15.8661 14.9999 15.4422 14.9999 15.0002V11.6668M11.6666 3.3335H16.6666M16.6666 3.3335V8.3335M16.6666 3.3335L8.33325 11.6668",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalLink);
export default __webpack_public_path__ + "static/media/icon_external-link.17f724fc537880a1660d4e108c02ed00.svg";
export { ForwardRef as ReactComponent };